import { WithChildrenCommonProps } from '@types';
import { getOptionListHeaderStylesAsClassName } from './option-list-header-styles';
import { Typography } from '@components/typography';

export const OptionListHeader = ({
  children,
  ...rest
}: WithChildrenCommonProps<unknown>): JSX.Element => {
  return (
    <Typography
      component="div"
      className={getOptionListHeaderStylesAsClassName()}
      variant="body2"
      {...rest}
    >
      {children}
    </Typography>
  );
};
